import InjuryStatus from './InjuryStatus';

export default InjuryStatus;



// WEBPACK FOOTER //
// ./src/app/components/TableControls/InjuryStatus/index.js